import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    configureAnalyticsRuntime,
    initGa4,
    trackGa4PageView,
    trackGa4Event,
} from "../lib/ga4";
import { useSiteSettings } from "../contexts/SiteSettingsContext";

const GSC_VERIFICATION = (process.env.REACT_APP_GSC_VERIFICATION || "").trim();

function upsertMeta(name, content) {
    if (!content) return;
    let node = document.head.querySelector(`meta[name="${name}"]`);
    if (!node) {
        node = document.createElement("meta");
        node.setAttribute("name", name);
        document.head.appendChild(node);
    }
    node.setAttribute("content", content);
}

export default function GA4Tracker() {
    const { settings } = useSiteSettings();
    const { pathname, search } = useLocation();

    useEffect(() => {
        configureAnalyticsRuntime(settings || {});
        initGa4();
        const token =
            (settings?.google_site_verification || "").trim() || GSC_VERIFICATION;
        if (token) {
            upsertMeta("google-site-verification", token);
        }
    }, [settings]);

    useEffect(() => {
        trackGa4PageView(pathname, search, document.title);

        // Lightweight funnel marker for SPA navigation insight.
        trackGa4Event("view_page_context", {
            page_path: pathname,
        });
    }, [pathname, search]);

    return null;
}
